import { isString } from 'lib';
import { URL_REGEX } from './regex';

export const convertUrlToLink = (text) => {
  if (!text) return '';
  if (isString(text)) {
    return text.replace(
      URL_REGEX,
      '<a class="link" href="$&" target="_blank">$&</a>'
    );
  }
  throw new Error('Invalid input: String expected');
};
